import React from 'react'

export default class ContactUs extends React.Component{
  render(){
    return(
      <div className="send-us-a-message">
        <div className="button">
          <span className="sketch-talk-bubble"></span>
          <a href="https://m.me/sketchize" target="_blank" rel="noopener noreferrer">SEND US A MESSAGE</a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.js